type CSSPropertyName = keyof CSSStyleDeclaration;
type CSSStyleMap = Partial<
  Record<CSSPropertyName, CSSStyleDeclaration[CSSPropertyName]>
>;

export const applyTemporaryStyles = (
  node: HTMLDivElement,
  styles: CSSStyleMap
) => {
  const previousStyles = Object.keys(styles).reduce<CSSStyleMap>(
    (accumulator, key) => {
      accumulator[key] = node.style[key];

      return accumulator;
    },
    {}
  );

  Object.assign(node.style, styles);

  return () => {
    Object.assign(node.style, previousStyles);
  };
};
